import BaseDialog from "./BaseDialog";
import Dropdown from './../../form_components/Dropdown';

export default class AddGlobalHandlerDialog extends BaseDialog {
    /**
     * Dialog for adding a new global intent handler
     * @module AddGlobalHandlerDialog
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.addHandle = this.handleAdd.bind(this);
        this.state = {
            globalIntent: "",
            newIntent: "",
            globalModule: "",
            newModule:""
        }
    }
    
    handleAdd() {
        this.props.context.setConfig("newIntent", this.state.globalIntent, this.state.globalModule);
        w2popup.close();
    }

    componentDidMount() {
        super.componentDidMount();
        document.addEventListener("ev-dialog-add", this.addHandle);
        document.addEventListener("ev-dialog-delete", this.deleteHandle);
        this.value = "";
    }

    unregister() {
        document.removeEventListener("ev-dialog-add", this.addHandle);
        document.removeEventListener("ev-dialog-delete", this.deleteHandle);
    }

    setConfig(key, value) {
        if (key === "globalIntent") {
            this.setState({ 'globalIntent': value })
        }
        if (key === 'globalModule') {
            this.setState({ 'globalModule': value })
        }
    }

    getConfig(key) {
        return this.state[key];
    }

    getIntents(globalIntents, intents) {
        let options = [];
        intents.forEach(intent => {
            const gIndex = globalIntents.findIndex(gi => gi.intent === intent.value);
            if (gIndex === -1) {
                options.push(intent);
            }
        })
        return options;
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        const intentSelection = this.getIntents(this.props.globalIntents, this.props.intents).findIndex(i => i.value === this.state.globalIntent);
        const moduleSelection = this.props.modules.findIndex(i => i.value === this.state.globalModule);
        return (
            <div className="wrapper">
                <div className="intents-container">
                    <div>
                        <Dropdown 
                            context={this}
                            options={this.getIntents(this.props.globalIntents, this.props.intents)}
                            optionName={"Select Intent"}
                            valKey={"globalIntent"}
                            selection={intentSelection}
                            label="Select an intent"
                            suppressUpdate={true}
                        />
                    </div>
                </div>
                <div className="handler-container">
                    <div>
                        <Dropdown 
                            context={this}
                            options={this.props.modules}
                            optionName={"Select Module"}
                            valKey={"globalModule"}
                            selection={moduleSelection}
                            label="Select a module to handle the intent (Optional)"
                            suppressUpdate={true}
                        />
                    </div>
                </div>
            </div>
        );
    } 
}